'use strict';

var extractAlpha$1 = require('../../../../../../../../_virtual/extractAlpha.cjs');

/**
 * extract alpha percentage from an alpha hex code
 */ const extractAlpha = (alphaHex)=>{
    const alpha = alphaHex.slice(7, 9);
    const opacity = parseInt(alpha, 16) / 255;
    return Math.round(opacity * 100);
};

extractAlpha$1.__exports.extractAlpha = extractAlpha;

module.exports = extractAlpha$1.__exports;
//# sourceMappingURL=extractAlpha.cjs.map
